import { render, staticRenderFns } from "./ivg-associati.vue?vue&type=template&id=14616901&scoped=true&"
import script from "./ivg-associati.vue?vue&type=script&lang=ts&"
export * from "./ivg-associati.vue?vue&type=script&lang=ts&"
import style0 from "./ivg-associati.vue?vue&type=style&index=0&id=14616901&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14616901",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsThePageTitleSection: require('/usr/src/nuxt-app/components/elements/ThePageTitleSection.vue').default,ElementsTheMap: require('/usr/src/nuxt-app/components/elements/TheMap.vue').default,ElementsTheError: require('/usr/src/nuxt-app/components/elements/TheError.vue').default})
